import { toaster } from 'uikit/Toaster'
import { api } from 'api'
import { useQuery } from '@tanstack/react-query'

export const useFetchBannerItem = (id: string) => {
  const response = useQuery({
    queryKey: ['bannerItem', id],
    queryFn: () => api.banner.fetchItem(id),
    gcTime: 0,
    enabled: !!id,
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить данные баннера',
      type: 'error',
    })
  }

  return response
}
